module.exports = __webpack_public_path__ + "static/media/ope_david_768x960.caa7e3d3.jpg";